// import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import Toolbar from "@mui/material/Toolbar";
import l10n from "../lib/l10n";
import { ButtonWholesale } from "./buttons/button-wholesale";
import ResponsiveMenu from "./ResponsiveMenu";
// import ThemeModeToggle from "./ThemeModeToggle";
import { Typography } from "@mui/material";
import BizLogo from "./BizLogo";
import { ButtonCloseMainModal } from "./buttons/button-close-main-modal";
import LoadingBox from "./LoadingBox";

function SidebarTop() {
  
  const getResponsiveMenuItems = () => {
    return l10n?.wppr_cjs_menu_items?.length
      ? l10n.wppr_cjs_menu_items
          .map(item => {
            if (!item.guid || item.guid.trim() === "") return null;
            return (
              <Button variant="contained-light" id={item.id} href={item.guid} target="_blank">
                <Typography noWrap>
                  {item.label}
                </Typography>
              </Button>
            );
          })
          .filter((i) => i)
      : [];
  };

  return (
    <>
      <AppBar>
        <Toolbar variant="dense">
          <LoadingBox>
            <ResponsiveMenu
              closeElement={<ButtonCloseMainModal />}
              startElement={<BizLogo />}
              endElement={
                <>
                  <ButtonWholesale />
                  {/* <ThemeModeToggle /> */}
                </>
              }
              responsiveItems={getResponsiveMenuItems()}
              menuItems={[]}
            />
          </LoadingBox>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default SidebarTop;
